import { colors } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

export const useModalStyles = makeStyles((theme) => ({
  root: {
    position: "absolute",
    outline: "none",
    boxShadow: theme.shadows[20],
    maxHeight: "100%",
    overflowY: "auto",
    maxWidth: "100%",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  smallModal: {
    width: 500,
  },
  largeModal: {
    width: 700,
    maxHeight: 700,
  },
  container: {
    marginTop: theme.spacing(3),
    height: 200,
  },
  formControl: {
    marginTop: 10,
    marginBottom: 10,
  },
  formControlLabel: {
    marginRight: 0,
  },
  actions: {
    justifyContent: "flex-end",
  },
  inputField: {
    marginTop: 16,
  },
  deactivateButton: {
    color: theme.palette.common.white,
    backgroundColor: colors.red[600],
    "&:hover": {
      backgroundColor: colors.red[900],
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        backgroundColor: colors.red[600],
      },
    },
  },
  closeIconAction: {
    "&:hover": {
      cursor: "pointer",
    },
    margin: 0,
  },
  clickableImg: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  mappingHeader: {
    textAlign: "center",
  },
  eventMappingBody: {
    marginBottom: 20,
  },
  fpEventLabel: {
    margin: 5,
  },
  // class for a container that has an icon in the center.
  centerIconContainer: {
    justifyContent: "center",
    alignItems: "center",
  },
  addMappingButton: {
    marginTop: 10,
  },
  addMappingButtonContainer: {
    justifyContent: "center",
  },
  icon: {
    display: "flex",
    marginRight: theme.spacing(1),
  },
}));
